/**
 * player disconnect detection. unused as of yet.
 * for it to work please uncomment this as well as every mention of socketIO in the codebase.
 */

/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { io } from 'socket.io-client';
import config from './Constants/fetch';

const disableForLocalhost = false;

function CreateListener({ userId, gameId, setSocket, languageShortCode }) {
    useEffect(() => {
        let socket;
        if (config.socketPrefix == 'https://projectmanagementgame.pmzone.com:3001/') {
            socket = io(config.socketPrefix, {
                transports: ['websocket'],
                withCredentials: true, // Include credentials like cookies if required
            });
        } else {
            socket = io(config.socketPrefix, {
                withCredentials: true, // Include credentials like cookies if required
                transports: ['websocket', 'polling'], // Enable both transports
            }); // Backend WebSocket URL
        }

        // Connect and send player ID
        socket.on('connect', () => {
            if (!disableForLocalhost || window.location.hostname != 'localhost') {
                socket.emit('player-connect', { gameId, userId, languageShortCode });
            }
        });

        // Handle disconnection
        socket.on('disconnect', () => {
            console.log('called disconnect, and Disconnected from server.');
        });

        setSocket(socket);
    }, [userId, gameId, setSocket]);
    return <></>;
}

export default CreateListener;
